import React, { useState } from 'react'
// import React, { useState, useEffect } from 'react'
import Add from './add'
import Grid from './grid'
import { AccordionWithArrow } from '../../../../components'
// import { consoleLog } from '../../../../util'
// import useLocalStorage from '../../../../hooks/useLocalStorage'
import { Wrapper } from './style'

const KeywordManagement = () => {
  const [updatedData, setUpdatedData] = useState(0)

  const updatedDataFunc = (obj = {}) => {
    setUpdatedData(updatedData + 1)
  }

  return (
    <Wrapper>
        <AccordionWithArrow title='Manage Keyword - Notes - Type - SubType' expanded={true} accordionstyle='fieldset'>
            <Add onChange={updatedDataFunc} />
            <Grid refreshData={updatedData} />
        </AccordionWithArrow>
    </Wrapper>
  )
}

export default KeywordManagement
